/* eslint-disable */
<template>
  <section class='content'>
    <div class='container-fluid'>
      <div class='block-header'>
        <h2>{{ nama }} </h2>
      </div>
      <div class='row clearfix'>
        <div class='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
          <div class='card'>
            <div class='header'>
              <h2>{{ id_pintasan != null ? 'Edit' : 'Tambah' }} {{ nama }}</h2>
            </div>
            <div class='body'>
              <form class='form-horizontal' v-on:submit.prevent='onSubmit'>
                <div class='row clearfix'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='judul'>Judul</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <form-line
                        id='judul'
                        type='text'
                        v-model='data.judul'
                      ></form-line>
                    </div>
                  </div>
                </div>
                <div class='row clearfix'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='penulis'>Penulis</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <form-line
                        id='penulis'
                        type='text'
                        v-model='data.penulis'
                      ></form-line>
                    </div>
                  </div>
                </div>
                <div class="row clearfix">
                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                    <label for="kategori">Kategori</label>
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                    <div class="form-group">
                      <div class="form-line">
                        <select v-model="data.kategori" class="form-control">
                          <option disabled value="">-- Pilih Kategori --</option>
                          <option v-for="item in categories" :key="item.id" :value="item.category">
                            {{ item.category }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='row clearfix' v-if='true'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='artikel'>Foto Thumbnail Artikel</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <vue-dropzone
                        ref='dropzoneThumnail'
                        id='dropzone-thumbnail'
                        :destroyDropzone='false'
                        :options='dropzoneOptionsBakground'
                        @vdropzone-removed-file='vremoved'
                        @vdropzone-success='onUploadSuccess'
                      ></vue-dropzone>
                    </div>
                  </div>
                </div>
                <div class='row clearfix' v-if='true'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='artikel'>Foto Penulis Artikel</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <vue-dropzone
                        ref='dropzonePenulis'
                        id='dropzone-penulis'
                        :destroyDropzone='false'
                        :options='dropzoneOptionsGif'
                        @vdropzone-removed-file='vremoved'
                        @vdropzone-success='onUploadSuccess'
                      ></vue-dropzone>
                    </div>
                  </div>
                </div>
                <div class='row clearfix'>
                  <div
                    class='col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5'
                  >
                    <button
                      v-if='id_pintasan != null'
                      @click='update'
                      type='button'
                      class='btn btn-warning waves-effect waves-button'
                      v-bind:disabled='isLoading'
                      v-waves.button
                    >
                      <i v-if='isLoading' class='fa fa-spin fa-spinner'></i
                      ><i v-if='!isLoading' class='material-icons'>save</i> Edit
                    </button>
                    <button
                      v-else
                      @click='save'
                      type='button'
                      class='btn btn-primary waves-effect waves-button'
                      v-bind:disabled='isLoading'
                      v-waves.button
                    >
                      <i v-if='isLoading' class='fa fa-spin fa-spinner'></i
                      ><i v-if='!isLoading' class='material-icons'>save</i>
                      Simpan
                    </button>
                    <button
                      @click='$router.go(-1)'
                      type='button'
                      class='btn btn-danger'
                      v-waves.button
                    >
                      <i class='material-icons'>cancel</i> Batal
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */

import Ckeditor from 'vue-ckeditor2'
import FormLine from '@/components/FormLine.vue'
import api from '@/helper/api'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'

export default {
  components: { FormLine, Ckeditor, vueDropzone: vue2Dropzone },
  name: 'PintasanInfo',
  data: function () {
    return {
      dropzoneOptionsBakground: {
        url: api.defaults.baseURL + '/upload_image_dropzone?tipe=THUMBNAIL_IMAGE',
        thumbnailWidth: 150,
        addRemoveLinks: true,
        maxFiles: 1,
        maxFilesize: 2,
        dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('_token') }
      },      
      dropzoneOptionsGif: {
        url: api.defaults.baseURL + '/upload_image_dropzone?tipe=PENULIS_IMAGE',
        thumbnailWidth: 150,
        addRemoveLinks: true,
        maxFiles: 1, 
        maxFilesize: 2,
        dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('_token') }
      },
      data: {
        icon: '',
        isauth: '',
        link: '',
        title:'',
        decription:'',
        gif: '',
      },
      gif:'',
      link:'',
      tanggal: '',
      file: '',
      nama: '',
      link: '',
      isLoading: false,
      init: false
    }
  },
  methods: {
    save () {
      this.isLoading = true
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
        .post('/insert_artikel', this.data)
        .then((result) => {
          if (result.data.code === 200) {
            this.$toastr.s('Tambah data berhasil')
            this.$router.replace('/main/informasi/' + this.link)
          } else {
            var msg = 'Tambah data gagal'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        })
        .catch((e) => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
    },
    update () {
      this.isLoading = true
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
        .post('/update_artikel/' + this.id_pintasan, this.data)
        .then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/informasi/' + this.link)
            this.$toastr.s('Ubah data berhasil')
          }
          this.isLoading = false
        })
        .catch((e) => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
    }, 
    getCategories () {
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
      .get('/getAllCategories')
      .then((res) => {
        this.categories = res.data.object
      })
      .catch((err) => {
        this.$toastr.e('Gagal mengambil data kategori')
        console.error(err)
      })
    },
    onUploadSuccess(file, response) {
      console.log("iniresponse dari dropzone",response)
      const idFile = response && response.object ? response.object.id : null;
      console.log("ini idfile",idFile);
      if(idFile){
        this.data.fileArtikelId.push(
         idFile
        );
      }
      console.log("ini fileArtikel",this.data.fileArtikelId)
    },
    getDetail () {
      this.init = true
      console.log("ini file get data edit",this.fileArtikelId)
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
        .get('/get_artikel/' + this.id_pintasan)
        .then((result) => {
          this.data = result.data.object
          if (!this.data.fileArtikelId) {
            this.data.fileArtikelId = []
          }
          this.data.kategori = result.data.object.category
          for (var i = 0; i < this.data.files.length; i++) {
            const fileItem = this.data.files[i]
            if (fileItem.fileType === 'THUMBNAIL_IMAGE') {
              this.$refs.dropzoneThumnail.manuallyAddFile(
                { name: fileItem ,size:fileItem.size, type: 'image/jpeg' },
                fileItem.file
              )
            } else if (fileItem.fileType === 'PENULIS_IMAGE') {
              this.$refs.dropzonePenulis.manuallyAddFile(
                { name: fileItem ,size:fileItem.size, type: 'image/jpeg' },
                fileItem.file
              )
            }
          }
          this.init = false
        })
        .catch((ex) => {
          console.error("Error getDetail:", ex)
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
          this.init = false
        })
    },
    sendingEvent (file, xhr, formData) {
      formData.append('id_pintasan', parseInt(this.id_pintasan))

      // Cek dropzone mana yang sedang mengirim file
      if (this.$refs.dropzoneArtikel.dropzone.files.includes(file)) {
        formData.append('tipe', 'artikel')
      } else if (this.$refs.dropzonePenulis.dropzone.files.includes(file)) {
        formData.append('tipe', 'penulis')
      }
      console.log(this.id_pintasan)
      formData.append('id_pintasan', parseInt(this.id_pintasan))
    },
    onSubmit () {
      if (this.id_pintasan != null) this.update()
      else this.save()
    },
    checkRoute (route) {
      console.log(route.name)
      if (route.name === 'TambahArtikel' || route.name === 'EditArtikel') {
        this.link = 'artikel'
        this.nama = 'Artikel'
      }
    },
    vremoved (file, xhr, error) {
      console.log("ini filenya", file)
      if (!this.init) this.delete(file.name.id)
    },
    delete (id) {
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
        .delete('/delete_file_artikel/' + id)
        .then((result) => {
          console.log(result.data.code)
          if (result.data.code === 200) {
            this.$toastr.s('Foto berhasil dihapus')
            this.$swal.close()
          } else {
            this.$toastr.e('Gagal menghapus foto')
            this.$swal.close()
          }
        })
        .catch((e) => {
          this.$swal.close()
        })
    }
  },
  mounted () {
    this.checkRoute(this.$route)
    this.id_pintasan = this.$route.params.id
    if (this.id_pintasan != null) {
      this.getDetail()
    }
    this.getCategories()
      // Tunggu CKEditor siap (delay kecil)
    this.$nextTick(() => {
    const editorInstance = this.$refs.ckeditor.instance;

    if (editorInstance) {
      editorInstance.on('fileUploadResponse', (evt) => {
        const data = evt.data;
        const xhr = data.fileLoader.xhr;
        
        console.log('File upload response:', xhr.responseText); // <-- Ini akan muncul sekarang
        const response = JSON.parse(xhr.responseText);

        console.log('Upload response:', response); // <-- Ini akan muncul sekarang
        this.data.fileArtikelId.push(response.id_file);

      });
    } else {
      console.warn('CKEditor instance belum tersedia');
    }
  });
  },
  watch: {
    $route (to, from) {
      this.checkRoute(to)
    },
    'data.judul'(newVal) {
    console.log('Isi judul sekarang:', newVal)
    },
    'data.kategori'(newVal) {
      console.log('Kategori dipilih:', newVal)
    },
    'data.kategori'(newVal) {
      console.log(this.fileArtikelId, newVal)
    },
    'data.content'(newVal) {
      console.log('Konten artikel berubah')
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/view/PintasanInformasi/PintasanInformasi.vue